import { inject } from '@angular/core';
import { Routes } from '@angular/router';

import { APP_ENVIRONMENT } from './core/utils/environment.token';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () =>
      import('./features/landing-page/landing-page.component').then((m) => m.LandingPageComponent),
  },
  {
    path: 'maintenance',
    canMatch: [() => inject(APP_ENVIRONMENT).production],
    loadComponent: () =>
      import('./features/maintenance/maintenance.component').then((m) => m.MaintenanceComponent),
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home',
  },
  {
    path: 'stations',
    loadComponent: () =>
      import('./features/station-list/station-list.component').then((m) => m.StationListComponent),
  },
  {
    path: 'stations/:id',
    loadComponent: () =>
      import('./features/station-details/station-details.component').then(
        (m) => m.StationDetailsComponent
      ),
  },
  {
    path: 'sources-status',
    redirectTo: 'admin/procesos/procesos-de-carga/estado',
  },
  {
    path: 'admin/estaciones',
    canMatch: [() => import('./core/guards/super-admin.guard').then((m) => m.superAdminGuard)],
    canActivate: [
      () => import('./core/guards/super-admin.guard').then((m) => m.superAdminActivateGuard),
    ],
    loadComponent: () =>
      import('./features/admin-stations/admin-stations.component').then(
        (m) => m.AdminStationsComponent
      ),
  },
  {
    path: 'admin/estaciones/:id',
    canMatch: [() => import('./core/guards/super-admin.guard').then((m) => m.superAdminGuard)],
    canActivate: [
      () => import('./core/guards/super-admin.guard').then((m) => m.superAdminActivateGuard),
    ],
    loadComponent: () =>
      import('./features/admin-stations/admin-station-detail/admin-station-detail.component').then(
        (m) => m.AdminStationDetailComponent
      ),
  },
  {
    path: 'admin/procesos/habilitar',
    redirectTo: '/admin/procesos/procesos-de-carga/habilitar',
  },
  {
    path: 'admin/procesos/pendientes-validacion',
    redirectTo: '/admin/nuevos-registros/listado',
  },
  {
    path: 'admin/nuevos-registros/listado',
    canMatch: [() => import('./core/guards/super-admin.guard').then((m) => m.superAdminGuard)],
    canActivate: [
      () => import('./core/guards/super-admin.guard').then((m) => m.superAdminActivateGuard),
    ],
    loadComponent: () =>
      import('./features/admin-processes/pending-validations/pending-validations.component').then(
        (m) => m.PendingValidationsComponent
      ),
  },
  {
    path: 'admin/nuevos-registros/crear',
    canMatch: [() => import('./core/guards/super-admin.guard').then((m) => m.superAdminGuard)],
    canActivate: [
      () => import('./core/guards/super-admin.guard').then((m) => m.superAdminActivateGuard),
    ],
    loadComponent: () =>
      import('./features/admin-new-registrations/register-user/register-user.component').then(
        (m) => m.RegisterUserComponent
      ),
  },
  {
    path: 'admin/nuevos-registros',
    canMatch: [() => import('./core/guards/super-admin.guard').then((m) => m.superAdminGuard)],
    canActivate: [
      () => import('./core/guards/super-admin.guard').then((m) => m.superAdminActivateGuard),
    ],
    loadComponent: () =>
      import('./features/admin-new-registrations/admin-new-registrations.component').then(
        (m) => m.AdminNewRegistrationsComponent
      ),
  },
  {
    path: 'admin/sistema/modulos',
    canMatch: [() => import('./core/guards/super-admin.guard').then((m) => m.superAdminGuard)],
    canActivate: [
      () => import('./core/guards/super-admin.guard').then((m) => m.superAdminActivateGuard),
    ],
    loadComponent: () =>
      import('./features/admin-system/manage-modules/manage-modules.component').then(
        (m) => m.ManageModulesComponent
      ),
  },
  {
    path: 'admin/sistema/email',
    canMatch: [() => import('./core/guards/admin.guard').then((m) => m.adminGuard)],
    canActivate: [() => import('./core/guards/admin.guard').then((m) => m.adminActivateGuard)],
    loadComponent: () =>
      import('./features/admin-system/email-admin/email-admin.component').then(
        (m) => m.EmailAdminComponent
      ),
  },
  {
    path: 'admin/sistema/email/configurar',
    canMatch: [() => import('./core/guards/admin.guard').then((m) => m.adminGuard)],
    canActivate: [() => import('./core/guards/admin.guard').then((m) => m.adminActivateGuard)],
    loadComponent: () =>
      import('./features/admin-system/email-module/email-module.component').then(
        (m) => m.EmailModuleComponent
      ),
  },
  {
    path: 'admin/sistema/email/envios',
    canMatch: [() => import('./core/guards/admin.guard').then((m) => m.adminGuard)],
    canActivate: [() => import('./core/guards/admin.guard').then((m) => m.adminActivateGuard)],
    loadComponent: () =>
      import('./features/admin-system/email-logs/email-logs.component').then(
        (m) => m.EmailLogsComponent
      ),
  },
  {
    path: 'admin/sistema/cache',
    canMatch: [() => import('./core/guards/admin.guard').then((m) => m.adminGuard)],
    canActivate: [() => import('./core/guards/admin.guard').then((m) => m.adminActivateGuard)],
    loadComponent: () =>
      import('./features/admin-system/cache-admin/cache-admin.component').then(
        (m) => m.CacheAdminComponent
      ),
  },
  {
    path: 'admin/procesos/procesos-de-carga',
    canMatch: [() => import('./core/guards/super-admin.guard').then((m) => m.superAdminGuard)],
    canActivate: [
      () => import('./core/guards/super-admin.guard').then((m) => m.superAdminActivateGuard),
    ],
    loadComponent: () =>
      import('./features/admin-processes/load-processes/load-processes.component').then(
        (m) => m.LoadProcessesComponent
      ),
  },
  {
    path: 'admin/procesos/procesos-de-carga/estado',
    canMatch: [() => import('./core/guards/admin.guard').then((m) => m.adminGuard)],
    canActivate: [() => import('./core/guards/admin.guard').then((m) => m.adminActivateGuard)],
    loadComponent: () =>
      import('./features/sources-status/sources-status.component').then(
        (m) => m.SourcesStatusComponent
      ),
  },
  {
    path: 'admin/procesos/procesos-de-carga/habilitar',
    canMatch: [() => import('./core/guards/super-admin.guard').then((m) => m.superAdminGuard)],
    canActivate: [
      () => import('./core/guards/super-admin.guard').then((m) => m.superAdminActivateGuard),
    ],
    loadComponent: () =>
      import('./features/admin-processes/manage-sources/manage-sources.component').then(
        (m) => m.ManageSourcesComponent
      ),
  },
  {
    path: 'admin/procesos/alertas',
    canMatch: [() => import('./core/guards/super-admin.guard').then((m) => m.superAdminGuard)],
    canActivate: [
      () => import('./core/guards/super-admin.guard').then((m) => m.superAdminActivateGuard),
    ],
    loadComponent: () =>
      import('./features/admin-processes/alert-evaluations/price-alert-evaluations.component').then(
        (m) => m.PriceAlertEvaluationsComponent
      ),
  },
  {
    path: 'admin/colecciones',
    canMatch: [() => import('./core/guards/admin.guard').then((m) => m.adminGuard)],
    canActivate: [() => import('./core/guards/admin.guard').then((m) => m.adminActivateGuard)],
    loadComponent: () =>
      import('./features/admin-collections/admin-collections.component').then(
        (m) => m.AdminCollectionsComponent
      ),
  },
  {
    path: 'admin/colecciones/tipos-combustible',
    canMatch: [() => import('./core/guards/admin.guard').then((m) => m.adminGuard)],
    canActivate: [() => import('./core/guards/admin.guard').then((m) => m.adminActivateGuard)],
    loadComponent: () =>
      import('./features/admin-collections/fuel-types-admin/fuel-types-admin.component').then(
        (m) => m.FuelTypesAdminComponent
      ),
  },
  {
    path: 'admin/configuracion',
    canMatch: [() => import('./core/guards/admin.guard').then((m) => m.adminGuard)],
    canActivate: [() => import('./core/guards/admin.guard').then((m) => m.adminActivateGuard)],
    loadComponent: () =>
      import('./features/admin-configuration/admin-configuration.component').then(
        (m) => m.AdminConfigurationComponent
      ),
  },
  {
    path: 'admin/procesos',
    canMatch: [() => import('./core/guards/super-admin.guard').then((m) => m.superAdminGuard)],
    canActivate: [
      () => import('./core/guards/super-admin.guard').then((m) => m.superAdminActivateGuard),
    ],
    loadComponent: () =>
      import('./features/admin-processes/admin-processes.component').then(
        (m) => m.AdminProcessesComponent
      ),
  },
  {
    path: 'admin/sistema',
    canMatch: [() => import('./core/guards/admin.guard').then((m) => m.adminGuard)],
    canActivate: [() => import('./core/guards/admin.guard').then((m) => m.adminActivateGuard)],
    loadComponent: () =>
      import('./features/admin-system/admin-system.component').then((m) => m.AdminSystemComponent),
  },
  {
    path: 'auth/login',
    loadComponent: () =>
      import('./features/auth/login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'magic-login',
    loadComponent: () =>
      import('./features/auth/magic-login/magic-login.component').then((m) => m.MagicLoginComponent),
  },
  {
    path: 'auth/reset-password',
    loadComponent: () =>
      import('./features/auth/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: 'reset-password',
    loadComponent: () =>
      import('./features/auth/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent
      ),
  },
  {
    path: 'auth/register',
    loadComponent: () =>
      import('./features/auth/register/register.component').then((m) => m.RegisterComponent)
  },
  {
    path: 'terminos',
    loadComponent: () =>
      import('./features/terms-of-use/terms-of-use.component').then((m) => m.TermsOfUseComponent),
  },
  {
    path: 'privacidad',
    loadComponent: () =>
      import('./features/privacy-policy/privacy-policy.component').then(
        (m) => m.PrivacyPolicyComponent
      ),
  },
  {
    path: 'aviso-legal',
    loadComponent: () =>
      import('./features/legal-disclaimer/legal-disclaimer.component').then(
        (m) => m.LegalDisclaimerComponent
      ),
  },
  {
    path: 'map',
    redirectTo: 'stations',
  },
  {
    path: 'favorites',
    canMatch: [() => import('./core/guards/auth.guard').then((m) => m.authGuard)],
    loadComponent: () =>
      import('./features/favorites/favorites.component').then((m) => m.FavoritesComponent),
  },
  {
    path: 'notifications',
    canMatch: [() => import('./core/guards/auth.guard').then((m) => m.authGuard)],
    loadComponent: () =>
      import('./features/alert-notifications/alert-notifications.component').then(
        (m) => m.AlertNotificationsComponent,
      ),
  },
  {
    path: 'alerts',
    canMatch: [() => import('./core/guards/auth.guard').then((m) => m.authGuard)],
    loadComponent: () =>
      import('./features/price-alerts/price-alerts.component').then((m) => m.PriceAlertsComponent),
  },
  {
    path: 'account',
    canMatch: [() => import('./core/guards/auth.guard').then((m) => m.authGuard)],
    loadComponent: () =>
      import('./features/account/account.component').then((m) => m.AccountComponent),
  },
  {
    path: '**',
    redirectTo: 'stations',
  },
];
